import { Injectable } from '@angular/core';
import { OutlookService } from '@maximizer/outlook/shared/data-access';

@Injectable()
export class TeamMemberService {
  private readonly genericDomains = new Set([
    'gmail.com',
    'googlemail.com',
    'outlook.com',
    'icloud.com',
    'yahoo.com',
    'yoohoo.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    'me.com',
    'mac.com',
    'ymail.com',
    'rocketmail.com',
    'yahoo.co.uk',
    'yahoo.co.in',
    'mail.com',
    'zoho.com',
    'fastmail.com',
    'hey.com',
  ]);

  constructor(private readonly outlookService: OutlookService) {}

  isTeamMember(email: string | null | undefined): boolean {
    if (!email) return false;

    const userEmail =
      this.outlookService.mailbox?.userProfile?.emailAddress?.toLowerCase();
    if (!userEmail) return false;

    const userParts = userEmail.split('@');
    const emailParts = email.toLowerCase().split('@');
    if (userParts.length < 2 || emailParts.length < 2) return false;

    const userDomain = userParts[1];
    const emailDomain = emailParts[1];

    if (this.genericDomains.has(userDomain)) return false;

    return userDomain === emailDomain;
  }
}
